import { EntityRepository } from '@record-it-npm/synchro-client';
import { EntityName } from 'record-it-time-common/EntityName';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';
import { AppEntityManagerEntityTypesByEntityName } from '../AppEntityManagerEntityTypesByEntityName';
import { ConstructionSite } from './constructionSiteTypes';
export class ConstructionSiteRepository extends EntityRepository<AppSynchronizationEnvironmentTypes, EntityName.ConstructionSite, AppEntityManagerEntityTypesByEntityName> {
  public getByUserGroupId(userGroupId: string): Array<ConstructionSite> {
    return this.getAll().filter(cs => cs.ownerUserGroupId === userGroupId);
  }
}